import React, { useEffect, useMemo, useState } from "react";
import Table from "../common/Table";
import fetchData from "../../api/fetchApi";
import PageHeader from "../common/PageHeader";
import { useNavigate } from "react-router-dom";

export default function PaymentMethodsTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newMethod, setNewMethod] = useState({ name: '', description: ''});
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [last, setLast] = useState(1);

  function getPages(current, last) {
    let pages = [];
    for (let i = 1; i <= last; i++) {
      pages.push(i);
    }
    return pages;
  }
  const navigate = useNavigate();

  // Toggle status API call
  async function handleToggleStatus(row) {
    try {
      setLoading(true);
      if (row.is_active) {
        await fetchData(`admin/payment-method/deactivate?uuid=${row.uuid}`, 'PUT');
      } else {
        await fetchData(`admin/payment-method/activate?uuid=${row.uuid}`, 'PUT');
      }
      await loadMethods();
    } catch (e) {
      setError('فشل في تعديل حالة طريقة الدفع');
    } finally {
      setLoading(false);
    }
  }
  const columns = useMemo(() => [
    { header: "الاسم", accessor: "name" },
    { header: "الوصف", accessor: "description" },
    { header: "الحالة", accessor: (row) => (
        console.log(row),
        <span className={`px-2 py-1 rounded text-xs font-bold ${row.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
          {row.is_active ? 'نشط' : 'غير نشط'}
        </span>
      ) },
    { header: "UUID", accessor: "uuid" },
  ], []);

  async function loadMethods() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetchData('admin/payment-methods');
      setRows(Array.isArray(res) ? res : res.items || []);
    } catch (e) {
      setError('فشل في جلب طرق الدفع');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadMethods();
  }, []);

  async function handleAddMethod(e) {
    e.preventDefault();
    setAddLoading(true);
    setAddError(null);
    try {
      await fetchData('admin/payment-method', 'POST', JSON.stringify(newMethod));
      setShowAddModal(false);
      setNewMethod({ name: '', description: '' });
      await loadMethods();
    } catch (err) {
      setAddError('فشل إضافة طريقة الدفع');
    } finally {
      setAddLoading(false);
    }
  }

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white">
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-bold mb-4">إضافة طريقة دفع جديدة</h3>
            <form onSubmit={handleAddMethod} className="space-y-4">
              <div>
                <label className="block mb-1 text-sm">الاسم</label>
                <input type="text" className="w-full border rounded-lg p-2" value={newMethod.name} onChange={e => setNewMethod({ ...newMethod, name: e.target.value })} required />
              </div>
              <div>
                <label className="block mb-1 text-sm">الوصف</label>
                <input type="text" className="w-full border rounded-lg p-2" value={newMethod.description} onChange={e => setNewMethod({ ...newMethod, description: e.target.value })} required />
              </div>
              <div>
                <label className="block mb-1 text-sm">نشط؟</label>
                <input type="checkbox" checked={newMethod.is_active} onChange={e => setNewMethod({ ...newMethod, is_active: e.target.checked })} />
              </div>
              {addError && <div className="text-red-600 text-sm">{addError}</div>}
              <div className="flex gap-2 justify-end mt-4">
                <button type="button" className="px-4 py-2 rounded bg-gray-200" onClick={() => setShowAddModal(false)}>إلغاء</button>
                <button type="submit" className="px-4 py-2 rounded bg-[#1A6AB3] text-white" disabled={addLoading}>{addLoading ? 'جاري الإضافة...' : 'إضافة'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <PageHeader title="طرق الدفع" total={rows.length} stats={[]}>
        <button className="px-4 py-2.5 rounded-lg text-white bg-[var(--Primary-Primary)] shadow-sm text-sm md:text-base flex" onClick={() => setShowAddModal(true)}>
          إضافة طريقة دفع جديدة
        </button>
      </PageHeader>
       <Table
                columns={columns}
                rows={rows}
                actions={[{ label: "تصدير" }, { label: "تصفية" }]}
                pagination={{
                  label: `الصفحة ${page} من ${last}`,
                  pages: getPages(page, last),
                  current: page,
                  last,
                  perPage,
                  onPageChange: (n) => {
                    if (n >= 1 && n <= last) setPage(n);
                  },
                  onPerPageChange: (n) => {
                    setPerPage(n);
                    setPage(1);
                  },
                  // onRowClick: (r) => navigate(`/laws/${r.uuid || r.id}`),
                  // onEdit: handleEdit,
                  // onStopPublish: handleStopPublish,
                  // onDelete: handleDelete,
                  
                }}   act= {[{
                      label: <div className="flex items-center gap-2">
                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.33341 2.66646H4.80008C4.05334 2.66646 3.67998 2.66646 3.39476 2.81179C3.14388 2.93962 2.9399 3.14359 2.81207 3.39448C2.66675 3.67969 2.66675 4.05306 2.66675 4.7998V11.1998C2.66675 11.9465 2.66675 12.3199 2.81207 12.6051C2.9399 12.856 3.14388 13.06 3.39476 13.1878C3.67998 13.3331 4.05334 13.3331 4.80008 13.3331H11.2001C11.9468 13.3331 12.3202 13.3331 12.6054 13.1878C12.8563 13.06 13.0603 12.856 13.1881 12.6051C13.3334 12.3199 13.3334 11.9465 13.3334 11.1998V8.33313M10.3334 3.66646L12.219 5.55208M7.17524 6.82464L11.6074 2.39248C12.1281 1.87178 12.9723 1.87178 13.493 2.39248C14.0137 2.91318 14.0137 3.7574 13.493 4.27809L8.91837 8.85274C8.41061 9.3605 8.15673 9.61438 7.86755 9.81629C7.61087 9.9955 7.33403 10.144 7.04273 10.2586C6.71455 10.3878 6.3626 10.4588 5.6587 10.6008L5.33342 10.6665L5.36505 10.445C5.47699 9.66144 5.53296 9.26965 5.66027 8.90387C5.77325 8.5793 5.92758 8.27063 6.11946 7.98551C6.33569 7.66419 6.61554 7.38434 7.17524 6.82464Z" stroke="#1A6AB3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> <p className="text-[#1A6AB3]">
          تعديل 
          </p></div>
        ,
                      onClick: (row) => navigate(`/admin/laws/${row.uuid}`)
                    },
                    {
                      label: <div className="flex items-center gap-2">
        
        
        <p className="text-[#15936E]">
          تعديل الحالة
        </p>
        </div>,
                      onClick: (row) => handleToggleStatus(row)
                    },
                    {
                      label: <div className="flex items-center gap-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.6667 3.33325H11.3334L10.6667 2.66659H5.33341L4.66675 3.33325H1.33341M12.6667 3.33325V12.6666C12.6667 13.1199 12.5261 13.5559 12.2192 13.8628C11.9123 14.1697 11.4763 14.3103 11.0231 14.3103H4.97608C4.52285 14.3103 4.08686 14.1697 3.77996 13.8628C
        3.47307 13.5559 3.33241 13.1199 3.33241 12.6666V3.33325H12.6667Z" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.66675 7.33325V11.3333" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.33325 7.33325V11.3333" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
         <p className="text-[#E02424]">
            حذف القانون
          </p></div>,
          
                      onClick: (row) => navigate(`/admin/users/${row.uuid}/delete`)
        
                    }
        
                    ]}
              />
      {loading && (
        <div className="mt-4 text-center text-sm text-gray-500">جاري التحميل...</div>
      )}
      {error && (
        <div className="mt-2 text-center text-sm text-red-600">{error}</div>
      )}
    </div>
  );
}
